import {RoomClientState} from '../RoomClientState.ts'
import {UIPopupController} from '../ui_popup/UIPopupController.ts'
import {CA} from '../analytics/Analytics.ts'
import {EnumUtils} from '../../../../shared/utils/EnumUtils.ts'
import {StorageWrapper} from '../StorageWrapper.ts'
import {clientI18n} from '../ClientI18n.ts'
import {TranslationObject} from '@colonist/i18n'
import {GameSpeedSettings, RoomSettingConstants} from '@colonist/game-base-types'
import RoomGameSpeeds from '@static/images/room_game_speeds.png'
import {socket} from '../EntryShared.ts'
import {setElementOnClick} from '../ui_utils/DomUtils'

export class UIRoomCenterSettingsSpeedView {
    container: HTMLDivElement
    speedInput: HTMLHeadingElement
    speedOptions: (keyof typeof GameSpeedSettings)[]
    speedRightArrow: HTMLImageElement
    speedLeftArrow: HTMLImageElement
    speedDivBody: HTMLDivElement
    speedInfo: HTMLImageElement
    speedSettings: typeof GameSpeedSettings
    speedDefaultSetting: keyof typeof GameSpeedSettings
    speedSocketCommand: (value: string) => void

    constructor(container: HTMLDivElement) {
        this.container = container
        this.initGameSpeedSettings()
        this.speedOptions = []
        UIRoomCenterSettingsSpeedView.setSpeedOptions(this.speedSettings, this.speedOptions)
    }

    initGameSpeedSettings() {
        this.speedInput = this.container.querySelector('#room_center_gamespeed_settings_input') as HTMLHeadingElement
        this.speedRightArrow = this.container.querySelector('#gamespeed_settings_right_arrow') as HTMLImageElement
        this.speedLeftArrow = this.container.querySelector('#gamespeed_settings_left_arrow') as HTMLImageElement
        this.speedDivBody = this.container.querySelector('#gamespeed_settings_body') as HTMLDivElement
        this.speedInfo = this.container.querySelector('#gamespeed_settings_speed_info') as HTMLImageElement
        this.speedSettings = GameSpeedSettings
        this.speedDefaultSetting = EnumUtils.getEnumKey(RoomSettingConstants.DEFAULT_GAME_SPEED_SETTING, GameSpeedSettings)
        const speedSocketCommand = (value: string) => {
            StorageWrapper.setRoomGameSpeedSetting(this.speedSettings[value])
            socket.roomClient.setGameSpeed(GameSpeedSettings[value])
        }
        this.speedSocketCommand = speedSocketCommand

        setElementOnClick(this.speedInfo, () => UIRoomCenterSettingsSpeedView.clickedSpeedInfo())
    }

    private static clickedSpeedInfo() {
        CA.sendGoogleAnalyticsEvent(CA.Category.Room, CA.Label.ClickedRoomGameSpeedInfo)
        const imageAlt = clientI18n.t('strings:roomPage.turnTimers')
        const gameSpeedChartImage = `<div class='room-map-preview-grid'><center><img src='${RoomGameSpeeds}' alt='${imageAlt}' style='width: 70%'></center>`
        const bodyImage: TranslationObject = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: gameSpeedChartImage,
                interpolation: {
                    escapeValue: false,
                },
            },
        }
        UIPopupController.createSimplePopup({key: 'strings:roomPage.turnTimers'}, bodyImage)
    }

    getSetting(newRoomState: RoomClientState): keyof typeof GameSpeedSettings {
        return EnumUtils.getEnumKey(newRoomState.gameSetting.gameSpeed, this.speedSettings)
    }

    private static setSpeedOptions(enumName: any, optionsArray: string[]) {
        EnumUtils.loopEnums(enumName, (innerElement, elementNo) => {
            optionsArray.push(enumName[innerElement].toString())
        })
    }
}
